import Model from './model.js';

export default class TimeEntry extends Model {
    urlRoot() { return '/TimeEntries'; }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize() {
        this.idAttribute = 'objectId';
        return super.initialize(...arguments);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/time-entry.js